import * as Path from '@farmersdog/constants/paths';

export const amazonTagPageViewRoutes = [
  Path.PATH_HOME,
  Path.PATH_SIGNUP_ME,
  Path.PATH_SIGNUP_RECIPES,
  Path.PATH_SIGNUP_CHECKOUT,
  Path.PATH_SIGNUP_SUCCESS,
];
